import { render, staticRenderFns } from "./OrderCardPositions.vue?vue&type=template&id=ddbed870&scoped=true"
import script from "./OrderCardPositions.vue?vue&type=script&lang=ts"
export * from "./OrderCardPositions.vue?vue&type=script&lang=ts"
import style0 from "./OrderCardPositions.vue?vue&type=style&index=0&id=ddbed870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbed870",
  null
  
)

export default component.exports